function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAttach = function SvgIconAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "m13.084 16.972-3.976 3.976a3.578 3.578 0 1 1-5.06-5.06l4.337-4.338a3.578 3.578 0 0 1 5.06 0l1.055.946M10.916 9.02l3.976-3.976a3.578 3.578 0 0 1 5.06 5.06l-4.338 4.338a3.578 3.578 0 0 1-5.06 0L9.5 13.496"
  }));
};
export default SvgIconAttach;